import {inlineError} from '@s-ui/decorators'
import {Service} from '@s-ui/domain'

export class GetSubscriptionMakesVehiclesService extends Service {
  constructor({httpVehiclesRepository}) {
    super()
    this._httpVehiclesRepository = httpVehiclesRepository
  }

  static create({httpVehiclesRepository}) {
    return new GetSubscriptionMakesVehiclesService({httpVehiclesRepository})
  }

  @inlineError
  async execute() {
    const [getSubscriptionMakesError, getSubscriptionMakesResponse] =
      await this._httpVehiclesRepository.getSubscriptionMakes()

    if (getSubscriptionMakesError) return Promise.reject(getSubscriptionMakesError)

    return getSubscriptionMakesResponse
  }
}
